import {
  BuildingEnergyModelFragment,
  EnergySystemType,
} from '../../../../generated/graphql'
import { FormValues as EsSystemFormValues } from '../../energy-system/form-values'
import {
  mapInputToFormValues as scheduleInputToForm,
  FormValues as ScheduleFormValues,
} from '../../schedule/form-values'
import { convertInputParametersToFormParameters } from './input-util'

export type VentilationInputTabFormValues = {
  values: EsSystemFormValues
  deviceScheduleValues?: ScheduleFormValues[]
}

export const getDefaultVentilationFormValues = (
  model: BuildingEnergyModelFragment,
): VentilationInputTabFormValues => {
  const defaultResult = {} as VentilationInputTabFormValues

  const energySystem = model.energySystems.find(
    (system) => system.type === EnergySystemType.Ventilation,
  )

  if (!energySystem) return defaultResult

  const esSystemValues = convertInputParametersToFormParameters(
    energySystem,
    undefined,
    model.area,
  )?.values

  const devices = esSystemValues?.parameters.ventilation?.deviceData
  if (!devices) return defaultResult

  const { schedules } = model

  const scheduleValues: ScheduleFormValues[] = []

  for (let i = 0; i < devices.length; i++) {
    const schedule = schedules.find((s) => s.id === devices[i].deviceScheduleId)
    if (!schedule) return defaultResult

    scheduleValues.push(scheduleInputToForm(schedule))
  }

  return { values: esSystemValues, deviceScheduleValues: scheduleValues }
}
